webpackJsonp([2345137460201621000],{

/***/ "./node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.4
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ "./node_modules/keycode/index.js":
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),

/***/ "./node_modules/material-ui-icons/FolderSpecial.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__("./node_modules/recompose/pure.js");
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__("./node_modules/material-ui/SvgIcon/index.js");
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z' });
	
	var FolderSpecial = function FolderSpecial(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	
	FolderSpecial = (0, _pure2.default)(FolderSpecial);
	FolderSpecial.muiName = 'SvgIcon';
	
	exports.default = FolderSpecial;

/***/ }),

/***/ "./node_modules/material-ui/Button/Button.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styleSheet = undefined;
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ref;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createStyleSheet = __webpack_require__("./node_modules/material-ui/styles/createStyleSheet.js");
	
	var _createStyleSheet2 = _interopRequireDefault(_createStyleSheet);
	
	var _withStyles = __webpack_require__("./node_modules/material-ui/styles/withStyles.js");
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__("./node_modules/material-ui/styles/colorManipulator.js");
	
	var _ButtonBase = __webpack_require__("./node_modules/material-ui/internal/ButtonBase.js");
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__("./node_modules/react/react.js").babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__("./node_modules/prop-types/index.js").any;
	
	var styleSheet = exports.styleSheet = (0, _createStyleSheet2.default)('MuiButton', function (theme) {
	  return {
	    root: (0, _extends3.default)({}, theme.typography.button, {
	      lineHeight: '1em',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      boxSizing: 'border-box',
	      minWidth: 88,
	      minHeight: 36,
	      padding: '11px ' + theme.spacing.unit * 2 + 'px',
	      borderRadius: 2,
	      color: theme.palette.text.primary,
	      backgroundColor: 'transparent',
	      transition: theme.transitions.create(['background-color', 'box-shadow'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.12),
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      }
	    }),
	    dense: {
	      padding: '10px ' + theme.spacing.unit + 'px',
	      minWidth: 64,
	      minHeight: 32,
	      fontSize: theme.typography.fontSize - 1
	    },
	    label: {
	      width: '100%',
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	    flatPrimary: {
	      color: theme.palette.primary[500],
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary[500], 0.12)
	      }
	    },
	    flatAccent: {
	      color: theme.palette.accent.A200,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.accent.A200, 0.12)
	      }
	    },
	    flatContrast: {
	      color: theme.palette.getContrastText(theme.palette.primary[500]),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.getContrastText(theme.palette.primary[500]), 0.12)
	      }
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    raised: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&$keyboardFocused': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.text.divider
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        '&$disabled': {
	          backgroundColor: theme.palette.text.divider
	        }
	      }
	    },
	    keyboardFocused: {},
	    raisedPrimary: {
	      color: theme.palette.getContrastText(theme.palette.primary[500]),
	      backgroundColor: theme.palette.primary[500],
	      '&:hover': {
	        backgroundColor: theme.palette.primary[700]
	      }
	    },
	    raisedAccent: {
	      color: theme.palette.getContrastText(theme.palette.accent.A200),
	      backgroundColor: theme.palette.accent.A200,
	      '&:hover': {
	        backgroundColor: theme.palette.accent.A400
	      }
	    },
	    raisedContrast: {
	      color: theme.palette.getContrastText(theme.palette.primary[500])
	    },
	    disabled: {
	      color: theme.palette.action.disabled
	    },
	    fab: {
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      }
	    }
	  };
	});
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element.isRequired ? babelPluginFlowReactPropTypes_proptype_Element.isRequired : babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__("./node_modules/prop-types/index.js").shape(babelPluginFlowReactPropTypes_proptype_Element).isRequired,
	  classes: __webpack_require__("./node_modules/prop-types/index.js").object,
	  className: __webpack_require__("./node_modules/prop-types/index.js").string,
	  color: __webpack_require__("./node_modules/prop-types/index.js").oneOf(['default', 'inherit', 'primary', 'accent', 'contrast']),
	  component: __webpack_require__("./node_modules/prop-types/index.js").oneOfType([__webpack_require__("./node_modules/prop-types/index.js").string, __webpack_require__("./node_modules/prop-types/index.js").func]),
	  dense: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  disabled: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  disableFocusRipple: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  disableRipple: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  fab: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  href: __webpack_require__("./node_modules/prop-types/index.js").string,
	  raised: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  type: __webpack_require__("./node_modules/prop-types/index.js").string
	};
	
	
	function Button(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      dense = props.dense,
	      disabled = props.disabled,
	      disableFocusRipple = props.disableFocusRipple,
	      fab = props.fab,
	      raised = props.raised,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'dense', 'disabled', 'disableFocusRipple', 'fab', 'raised']);
	
	
	  var flat = !raised && !fab;
	  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.root, true), (0, _defineProperty3.default)(_classNames, classes.raised, raised || fab), (0, _defineProperty3.default)(_classNames, classes.fab, fab), (0, _defineProperty3.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty3.default)(_classNames, classes.flatPrimary, flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.flatAccent, flat && color === 'accent'), (0, _defineProperty3.default)(_classNames, classes.flatContrast, flat && color === 'contrast'), (0, _defineProperty3.default)(_classNames, classes.raisedPrimary, !flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.raisedAccent, !flat && color === 'accent'), (0, _defineProperty3.default)(_classNames, classes.raisedContrast, !flat && color === 'contrast'), (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({
	      className: className,
	      disabled: disabled,
	      focusRipple: !disableFocusRipple,
	      keyboardFocusedClassName: classes.keyboardFocused
	    }, other),
	    _react2.default.createElement(
	      'span',
	      { className: classes.label },
	      children
	    )
	  );
	}
	
	Button.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  color: require('prop-types').oneOf(['default']).isRequired,
	  dense: require('prop-types').bool.isRequired,
	  disabled: require('prop-types').bool.isRequired,
	  fab: require('prop-types').bool.isRequired,
	  disableFocusRipple: require('prop-types').bool.isRequired,
	  raised: require('prop-types').bool.isRequired,
	  disableRipple: require('prop-types').bool.isRequired,
	  type: require('prop-types').oneOf(['button']).isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element.isRequired ? babelPluginFlowReactPropTypes_proptype_Element.isRequired : babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element).isRequired
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'color', require('prop-types').oneOf(['default', 'inherit', 'primary', 'accent', 'contrast'])), (0, _defineProperty3.default)(_ref, 'component', require('prop-types').oneOfType([require('prop-types').string, require('prop-types').func])), (0, _defineProperty3.default)(_ref, 'dense', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'disabled', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'disableFocusRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'disableRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'fab', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'href', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'raised', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'type', require('prop-types').string), _ref) : {};
	Button.defaultProps = {
	  color: 'default',
	  dense: false,
	  disabled: false,
	  fab: false,
	  disableFocusRipple: false,
	  raised: false,
	  disableRipple: false,
	  type: 'button'
	};
	
	exports.default = (0, _withStyles2.default)(styleSheet)(Button);

/***/ }),

/***/ "./node_modules/material-ui/Button/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__("./node_modules/material-ui/Button/Button.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/material-ui/SvgIcon/SvgIcon.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styleSheet = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createStyleSheet = __webpack_require__("./node_modules/material-ui/styles/createStyleSheet.js");
	
	var _createStyleSheet2 = _interopRequireDefault(_createStyleSheet);
	
	var _withStyles = __webpack_require__("./node_modules/material-ui/styles/withStyles.js");
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleSheet = exports.styleSheet = (0, _createStyleSheet2.default)('MuiSvgIcon', function (theme) {
	  return {
	    root: {
	      display: 'inline-block',
	      fill: 'currentColor',
	      height: 24,
	      width: 24,
	      userSelect: 'none',
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    }
	  };
	}); //  weak
	
	function SvgIcon(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      titleAccess = props.titleAccess,
	      viewBox = props.viewBox,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'titleAccess', 'viewBox']);
	
	
	  return _react2.default.createElement(
	    'svg',
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, className),
	      focusable: false,
	      viewBox: viewBox,
	      'aria-hidden': titleAccess ? 'false' : 'true'
	    }, other),
	    titleAccess ? _react2.default.createElement(
	      'title',
	      null,
	      titleAccess
	    ) : null,
	    children
	  );
	}
	
	SvgIcon.propTypes =  false ? {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes2.default.string,
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an svg element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the svg will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	
	SvgIcon.defaultProps = {
	  viewBox: '0 0 24 24'
	};
	
	SvgIcon.muiName = 'SvgIcon';
	
	exports.default = (0, _withStyles2.default)(styleSheet)(SvgIcon);

/***/ }),

/***/ "./node_modules/material-ui/SvgIcon/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SvgIcon = __webpack_require__("./node_modules/material-ui/SvgIcon/SvgIcon.js");
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SvgIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/material-ui/internal/ButtonBase.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styleSheet = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ref2, _ref3; //  weak
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _warning = __webpack_require__("./node_modules/warning/browser.js");
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _createStyleSheet = __webpack_require__("./node_modules/material-ui/styles/createStyleSheet.js");
	
	var _createStyleSheet2 = _interopRequireDefault(_createStyleSheet);
	
	var _withStyles = __webpack_require__("./node_modules/material-ui/styles/withStyles.js");
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _keyboardFocus = __webpack_require__("./node_modules/material-ui/utils/keyboardFocus.js");
	
	var _TouchRipple = __webpack_require__("./node_modules/material-ui/internal/TouchRipple.js");
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _createRippleHandler = __webpack_require__("./node_modules/material-ui/internal/createRippleHandler.js");
	
	var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__("./node_modules/react/react.js").babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__("./node_modules/prop-types/index.js").any;
	
	var styleSheet = exports.styleSheet = (0, _createStyleSheet2.default)('MuiButtonBase', function (theme) {
	  return {
	    root: {
	      position: 'relative',
	      // Remove grey highlight
	      WebkitTapHighlightColor: theme.palette.common.transparent,
	      outline: 'none',
	      border: 0,
	      cursor: 'pointer',
	      userSelect: 'none',
	      appearance: 'none',
	      textDecoration: 'none',
	      // So we take precedent over the style of a native <a /> element.
	      color: 'inherit'
	    },
	    disabled: {
	      cursor: 'default'
	    }
	  };
	});
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  centerRipple: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__("./node_modules/prop-types/index.js").shape(babelPluginFlowReactPropTypes_proptype_Element),
	  classes: __webpack_require__("./node_modules/prop-types/index.js").object,
	  className: __webpack_require__("./node_modules/prop-types/index.js").string,
	  component: __webpack_require__("./node_modules/prop-types/index.js").oneOfType([__webpack_require__("./node_modules/prop-types/index.js").string, __webpack_require__("./node_modules/prop-types/index.js").func]),
	  disabled: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  disableRipple: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  focusRipple: __webpack_require__("./node_modules/prop-types/index.js").bool,
	  keyboardFocusedClassName: __webpack_require__("./node_modules/prop-types/index.js").string,
	  onBlur: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onClick: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onFocus: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onKeyboardFocus: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onKeyDown: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onKeyUp: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onMouseDown: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onMouseLeave: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onMouseUp: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onTouchEnd: __webpack_require__("./node_modules/prop-types/index.js").func,
	  onTouchStart: __webpack_require__("./node_modules/prop-types/index.js").func,
	  role: __webpack_require__("./node_modules/prop-types/index.js").string,
	  tabIndex: __webpack_require__("./node_modules/prop-types/index.js").string,
	  type: __webpack_require__("./node_modules/prop-types/index.js").string.isRequired
	};
	
	/**
	 * @ignore - internal component.
	 */
	var ButtonBase = function (_Component) {
	  (0, _inherits3.default)(ButtonBase, _Component);
	
	  function ButtonBase() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ButtonBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      keyboardFocused: false
	    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 40, _this.keyboardFocusMaxCheckTimes = 5, _this.focus = function () {
	      _this.button.focus();
	    }, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          component = _this$props.component,
	          focusRipple = _this$props.focusRipple,
	          onKeyDown = _this$props.onKeyDown,
	          onClick = _this$props.onClick;
	
	      var key = (0, _keycode2.default)(event);
	
	      // Check if key is already down to avoid repeats being counted as multiple activations
	      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && key === 'space') {
	        _this.keyDown = true;
	        event.persist();
	        _this.ripple.stop(event, function () {
	          _this.ripple.start(event);
	        });
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	
	      // Keyboard accessibility for non interactive elements
	      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
	        event.preventDefault();
	        onClick(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.state.keyboardFocused) {
	        _this.keyDown = false;
	        event.persist();
	        _this.ripple.stop(event, function () {
	          return _this.ripple.pulsate(event);
	        });
	      }
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(event);
	      }
	    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
	      clearTimeout(_this.keyboardFocusTimeout);
	      (0, _keyboardFocus.focusKeyPressed)(false);
	      if (_this.state.keyboardFocused) {
	        _this.setState({ keyboardFocused: false });
	      }
	    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
	      if (_this.state.keyboardFocused) {
	        event.preventDefault();
	      }
	    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
	      _this.setState({ keyboardFocused: false });
	    }), _this.handleFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      if (_this.button) {
	        event.persist();
	
	        var keyboardFocusCallback = _this.onKeyboardFocusHandler.bind(_this, event);
	        (0, _keyboardFocus.detectKeyboardFocus)(_this, (0, _reactDom.findDOMNode)(_this.button), keyboardFocusCallback);
	      }
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.onKeyboardFocusHandler = function (event) {
	      _this.keyDown = false;
	      _this.setState({ keyboardFocused: true });
	
	      if (_this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ButtonBase, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _keyboardFocus.listenForFocusKeys)();
	
	       false ? (0, _warning2.default)(this.button, 'Material-UI: please provide a class to the component property.\n      The keyboard focus logic needs a reference to work correctly.') : void 0;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.props.focusRipple && nextState.keyboardFocused && !this.state.keyboardFocused && !this.props.disableRipple) {
	        this.ripple.pulsate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.keyboardFocusTimeout);
	    } // Used to help track keyboard activation keyDown
	
	  }, {
	    key: 'renderRipple',
	    value: function renderRipple() {
	      var _this2 = this;
	
	      if (!this.props.disableRipple && !this.props.disabled) {
	        return _react2.default.createElement(_TouchRipple2.default, {
	          innerRef: function innerRef(node) {
	            _this2.ripple = node;
	          },
	          center: this.props.centerRipple
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames,
	          _this3 = this;
	
	      var _props = this.props,
	          centerRipple = _props.centerRipple,
	          children = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          component = _props.component,
	          disabled = _props.disabled,
	          disableRipple = _props.disableRipple,
	          focusRipple = _props.focusRipple,
	          keyboardFocusedClassName = _props.keyboardFocusedClassName,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onKeyDown = _props.onKeyDown,
	          onKeyUp = _props.onKeyUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onTouchEnd = _props.onTouchEnd,
	          onTouchStart = _props.onTouchStart,
	          tabIndex = _props.tabIndex,
	          type = _props.type,
	          other = (0, _objectWithoutProperties3.default)(_props, ['centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchStart', 'tabIndex', 'type']);
	
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, keyboardFocusedClassName, keyboardFocusedClassName && this.state.keyboardFocused), _classNames), classNameProp);
	
	      var buttonProps = {};
	
	      var ComponentProp = component;
	
	      if (!ComponentProp) {
	        if (other.href) {
	          ComponentProp = 'a';
	        } else {
	          ComponentProp = 'button';
	        }
	      }
	
	      if (ComponentProp === 'button') {
	        buttonProps.type = type || 'button';
	      }
	
	      if (ComponentProp !== 'a') {
	        buttonProps.role = buttonProps.role || 'button';
	        buttonProps.disabled = disabled;
	      }
	
	      return _react2.default.createElement(
	        ComponentProp,
	        (0, _extends3.default)({
	          ref: function ref(node) {
	            _this3.button = node;
	          },
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseUp: this.handleMouseUp,
	          onTouchEnd: this.handleTouchEnd,
	          onTouchStart: this.handleTouchStart,
	          tabIndex: disabled ? '-1' : tabIndex,
	          className: className
	        }, buttonProps, other),
	        children,
	        this.renderRipple()
	      );
	    }
	  }]);
	  return ButtonBase;
	}(_react.Component);
	
	ButtonBase.defaultProps = {
	  centerRipple: false,
	  classes: {},
	  focusRipple: false,
	  disableRipple: false,
	  tabIndex: '0',
	  type: 'button'
	};
	ButtonBase.propTypes =  false ? (_ref2 = {
	  centerRipple: require('prop-types').bool.isRequired,
	  classes: require('prop-types').object.isRequired,
	  focusRipple: require('prop-types').bool.isRequired,
	  disableRipple: require('prop-types').bool.isRequired,
	  tabIndex: require('prop-types').string.isRequired,
	  type: require('prop-types').string.isRequired
	}, (0, _defineProperty3.default)(_ref2, 'centerRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'children', typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element)), (0, _defineProperty3.default)(_ref2, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'component', require('prop-types').oneOfType([require('prop-types').string, require('prop-types').func])), (0, _defineProperty3.default)(_ref2, 'disabled', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'disableRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'focusRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref2, 'keyboardFocusedClassName', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'onBlur', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onClick', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onKeyboardFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onKeyDown', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onMouseDown', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onMouseLeave', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onMouseUp', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onTouchEnd', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'onTouchStart', require('prop-types').func), (0, _defineProperty3.default)(_ref2, 'role', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'tabIndex', require('prop-types').string), (0, _defineProperty3.default)(_ref2, 'type', require('prop-types').string.isRequired), _ref2) : {};
	ButtonBase.propTypes =  false ? (_ref3 = {
	  centerRipple: require('prop-types').bool.isRequired,
	  classes: require('prop-types').object.isRequired,
	  focusRipple: require('prop-types').bool.isRequired,
	  disableRipple: require('prop-types').bool.isRequired,
	  tabIndex: require('prop-types').string.isRequired,
	  type: require('prop-types').string.isRequired
	}, (0, _defineProperty3.default)(_ref3, 'centerRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'children', typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element)), (0, _defineProperty3.default)(_ref3, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'component', require('prop-types').oneOfType([require('prop-types').string, require('prop-types').func])), (0, _defineProperty3.default)(_ref3, 'disabled', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'disableRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'focusRipple', require('prop-types').bool), (0, _defineProperty3.default)(_ref3, 'keyboardFocusedClassName', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'onBlur', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onClick', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onKeyboardFocus', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onKeyDown', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onKeyUp', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onMouseDown', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onMouseLeave', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onMouseUp', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onTouchEnd', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'onTouchStart', require('prop-types').func), (0, _defineProperty3.default)(_ref3, 'role', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'tabIndex', require('prop-types').string), (0, _defineProperty3.default)(_ref3, 'type', require('prop-types').string.isRequired), _ref3) : {};
	exports.default = (0, _withStyles2.default)(styleSheet)(ButtonBase);

/***/ }),

/***/ "./node_modules/material-ui/internal/Ripple.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Transition = __webpack_require__("./node_modules/react-transition-group/Transition.js");
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	//  weak
	
	var Ripple = function (_Component) {
	  (0, _inherits3.default)(Ripple, _Component);
	
	  function Ripple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Ripple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rippleVisible: false
	    }, _this.handleEnter = function () {
	      _this.setState({
	        rippleVisible: true
	      });
	    }, _this.handleExit = function () {
	      _this.setState({
	        rippleLeaving: true
	      });
	    }, _this.getRippleStyles = function (props) {
	      var rippleSize = props.rippleSize,
	          rippleX = props.rippleX,
	          rippleY = props.rippleY;
	
	
	      return {
	        width: rippleSize,
	        height: rippleSize,
	        top: -(rippleSize / 2) + rippleY,
	        left: -(rippleSize / 2) + rippleX
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Ripple, [{
	    key: 'render',
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          pulsate = _props.pulsate,
	          rippleX = _props.rippleX,
	          rippleY = _props.rippleY,
	          rippleSize = _props.rippleSize,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
	      var _state = this.state,
	          rippleVisible = _state.rippleVisible,
	          rippleLeaving = _state.rippleLeaving;
	
	
	      var className = (0, _classnames2.default)(classes.wrapper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.wrapperLeaving, rippleLeaving), (0, _defineProperty3.default)(_classNames, classes.wrapperPulsating, pulsate), _classNames), classNameProp);
	
	      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.rippleVisible, rippleVisible), (0, _defineProperty3.default)(_classNames2, classes.rippleFast, pulsate), _classNames2));
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
	        _react2.default.createElement(
	          'span',
	          { className: className },
	          _react2.default.createElement('span', { className: rippleClassName, style: this.getRippleStyles(this.props) })
	        )
	      );
	    }
	  }]);
	  return Ripple;
	}(_react.Component);
	
	Ripple.defaultProps = {
	  pulsate: false
	};
	
	
	Ripple.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes2.default.bool,
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes2.default.number.isRequired,
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes2.default.number.isRequired,
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes2.default.number.isRequired
	} : {};
	
	exports.default = Ripple;

/***/ }),

/***/ "./node_modules/material-ui/internal/TouchRipple.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styleSheet = undefined;
	
	var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__("./node_modules/babel-runtime/helpers/toConsumableArray.js");
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createStyleSheet = __webpack_require__("./node_modules/material-ui/styles/createStyleSheet.js");
	
	var _createStyleSheet2 = _interopRequireDefault(_createStyleSheet);
	
	var _withStyles = __webpack_require__("./node_modules/material-ui/styles/withStyles.js");
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Ripple = __webpack_require__("./node_modules/material-ui/internal/Ripple.js");
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	var DURATION = 550;
	
	var styleSheet = exports.styleSheet = (0, _createStyleSheet2.default)('MuiTouchRipple', function (theme) {
	  return {
	    root: {
	      display: 'block',
	      position: 'absolute',
	      overflow: 'hidden',
	      borderRadius: 'inherit',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      pointerEvents: 'none',
	      zIndex: 0
	    },
	    wrapper: {
	      opacity: 1
	    },
	    wrapperLeaving: {
	      opacity: 0,
	      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
	    },
	    wrapperPulsating: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      animation: 'mui-ripple-pulsate 1500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite',
	      rippleVisible: {
	        opacity: 0.2
	      }
	    },
	    '@keyframes mui-ripple-enter': {
	      '0%': {
	        transform: 'scale(0)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    },
	    '@keyframes mui-ripple-exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes mui-ripple-pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.9)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    },
	    ripple: {
	      width: 50,
	      height: 50,
	      left: 0,
	      top: 0,
	      opacity: 0,
	      position: 'absolute',
	      borderRadius: '50%',
	      background: 'currentColor'
	    },
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
	    },
	    rippleFast: {
	      animationDuration: '200ms'
	    }
	  };
	});
	
	/**
	 * @ignore - internal component.
	 */
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      nextKey: 0,
	      ripples: []
	    }, _this.ignoringMouseDown = false, _this.pulsate = function () {
	      _this.start({}, { pulsate: true });
	    }, _this.start = function () {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var cb = arguments[2];
	      var _options$pulsate = options.pulsate,
	          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
	          _options$center = options.center,
	          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center;
	
	
	      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
	        _this.ignoringMouseDown = false;
	        return;
	      }
	
	      if (event.type === 'touchstart') {
	        _this.ignoringMouseDown = true;
	      }
	
	      var ripples = _this.state.ripples;
	
	      var element = _reactDom2.default.findDOMNode(_this);
	      var rect = element ? // $FlowFixMe
	      element.getBoundingClientRect() : {
	        width: 0,
	        height: 0,
	        left: 0,
	        top: 0
	      };
	
	      // Get the size of the ripple
	      var rippleX = void 0;
	      var rippleY = void 0;
	      var rippleSize = void 0;
	
	      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	        rippleX = Math.round(rect.width / 2);
	        rippleY = Math.round(rect.height / 2);
	      } else {
	        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	        rippleX = Math.round(clientX - rect.left);
	        rippleY = Math.round(clientY - rect.top);
	      }
	
	      if (center) {
	        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
	
	        // For some reason the animation is broken on Mobile Chrome if the size if even.
	        if (rippleSize % 2 === 0) {
	          rippleSize += 1;
	        }
	      } else {
	        var sizeX = Math.max(
	        // $FlowFixMe
	        Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	        var sizeY = Math.max(
	        // $FlowFixMe
	        Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	      }
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
	        key: _this.state.nextKey,
	        classes: _this.props.classes,
	        timeout: {
	          exit: DURATION,
	          enter: DURATION
	        },
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	
	      _this.setState({
	        nextKey: _this.state.nextKey + 1,
	        ripples: ripples
	      }, cb);
	    }, _this.stop = function (event, cb) {
	      var ripples = _this.state.ripples;
	
	      if (ripples && ripples.length) {
	        _this.setState({
	          ripples: ripples.slice(1)
	        }, cb);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Used to filter out mouse emulated events on mobile.
	
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          center = _props.center,
	          classes = _props.classes,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);
	
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({
	          component: 'span',
	          enter: true,
	          exit: true,
	          className: (0, _classnames2.default)(classes.root, className)
	        }, other),
	        this.state.ripples
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  center: false
	};
	
	
	TouchRipple.propTypes =  false ? {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes2.default.bool,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styleSheet)(TouchRipple);

/***/ }),

/***/ "./node_modules/material-ui/internal/createRippleHandler.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function createRippleHandler(instance, eventName, action, cb) {
	  return function handleEvent(event) {
	    if (cb) {
	      cb.call(instance, event);
	    }
	
	    if (event.defaultPrevented) {
	      return false;
	    }
	
	    if (instance.ripple) {
	      instance.ripple[action](event);
	    }
	
	    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
	      instance.props['on' + eventName](event);
	    }
	
	    return true;
	  };
	}
	
	exports.default = createRippleHandler;

/***/ }),

/***/ "./node_modules/material-ui/utils/addEventListener.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__("./node_modules/dom-helpers/events/on.js");
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__("./node_modules/dom-helpers/events/off.js");
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/material-ui/utils/keyboardFocus.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusKeyPressed = focusKeyPressed;
	exports.detectKeyboardFocus = detectKeyboardFocus;
	exports.listenForFocusKeys = listenForFocusKeys;
	
	var _keycode = __webpack_require__("./node_modules/keycode/index.js");
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _contains = __webpack_require__("./node_modules/dom-helpers/query/contains.js");
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__("./node_modules/material-ui/utils/addEventListener.js");
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right']; //  weak
	
	var internal = {
	  listening: false,
	  focusKeyPressed: false
	};
	
	function isFocusKey(event) {
	  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
	}
	
	function focusKeyPressed(pressed) {
	  if (typeof pressed !== 'undefined') {
	    internal.focusKeyPressed = Boolean(pressed);
	  }
	
	  return internal.focusKeyPressed;
	}
	
	function detectKeyboardFocus(instance, element, cb) {
	  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  instance.keyboardFocusTimeout = setTimeout(function () {
	    if (focusKeyPressed() && (document.activeElement === element || (0, _contains2.default)(element, document.activeElement))) {
	      cb();
	    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
	      detectKeyboardFocus(instance, element, cb, attempt + 1);
	    }
	  }, instance.keyboardFocusCheckTime);
	}
	
	function listenForFocusKeys() {
	  if (!internal.listening) {
	    (0, _addEventListener2.default)(window, 'keyup', function (event) {
	      if (isFocusKey(event)) {
	        internal.focusKeyPressed = true;
	      }
	    });
	    internal.listening = true;
	  }
	}

/***/ }),

/***/ "./node_modules/react-icons/lib/fa/calendar.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__("./node_modules/react-icon-base/lib/index.js");
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendar = function FaCalendar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h6.4v-6.4h-6.4v6.4z m7.8 0h7.2v-6.4h-7.2v6.4z m-7.8-7.8h6.4v-7.2h-6.4v7.2z m7.8 0h7.2v-7.2h-7.2v7.2z m-7.8-8.6h6.4v-6.4h-6.4v6.4z m16.4 16.4h7.1v-6.4h-7.1v6.4z m-8.6-16.4h7.2v-6.4h-7.2v6.4z m17.2 16.4h6.4v-6.4h-6.4v6.4z m-8.6-7.8h7.1v-7.2h-7.1v7.2z m-7.9-19.3v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m16.5 19.3h6.4v-7.2h-6.4v7.2z m-8.6-8.6h7.1v-6.4h-7.1v6.4z m8.6 0h6.4v-6.4h-6.4v6.4z m0.7-10.7v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.2 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendar;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-simple-line-icons/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__("./node_modules/simple-line-icons/css/simple-line-icons.css");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var fontSize = function fontSize(size) {
	  if (size.toLowerCase() === 'large') {
	    return '22pt';
	  } else if (size.toLowerCase() === 'small') {
	    return '8pt';
	  }
	  return '18px';
	};
	
	var SimpleLineIcon = function SimpleLineIcon(_ref) {
	  var name = _ref.name,
	      color = _ref.color,
	      size = _ref.size,
	      style = _ref.style,
	      rest = _objectWithoutProperties(_ref, ['name', 'color', 'size', 'style']);
	
	  return _react2.default.createElement('div', _extends({
	    className: 'icon-' + name,
	    style: _extends({
	      color: color,
	      fontSize: fontSize(size)
	    }, style)
	  }, rest));
	};
	
	SimpleLineIcon.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOf(['Large', 'large', 'Medium', 'medium', 'Small', 'small']),
	  style: _propTypes2.default.object
	};
	
	SimpleLineIcon.defaultProps = {
	  color: null,
	  size: 'Medium',
	  style: {}
	};
	
	exports.default = SimpleLineIcon;

/***/ }),

/***/ "./node_modules/react-transition-group/Transition.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	
	    if (this.nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (this.nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	
	      this.nextStatus = null;
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    this.setState(nextState, this.setNextCallback(callback));
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `apprear` only an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "enter" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them throguh if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifiying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifiying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifiying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ "./node_modules/recompose/pure.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__("./node_modules/recompose/shouldUpdate.js");
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__("./node_modules/recompose/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__("./node_modules/recompose/setDisplayName.js");
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__("./node_modules/recompose/wrapDisplayName.js");
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ }),

/***/ "./node_modules/recompose/setDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__("./node_modules/recompose/setStatic.js");
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),

/***/ "./node_modules/recompose/setStatic.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),

/***/ "./node_modules/recompose/shallowEqual.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__("./node_modules/fbjs/lib/shallowEqual.js");
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),

/***/ "./node_modules/recompose/shouldUpdate.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _setDisplayName = __webpack_require__("./node_modules/recompose/setDisplayName.js");
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__("./node_modules/recompose/wrapDisplayName.js");
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__("./node_modules/recompose/createEagerFactory.js");
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ }),

/***/ "./node_modules/simple-line-icons/css/simple-line-icons.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:simple-line-icons;src:url(" + __webpack_require__("./node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0") + ");src:url(" + __webpack_require__("./node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0") + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__("./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0") + ") format(\"woff2\"),url(" + __webpack_require__("./node_modules/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0") + ") format(\"truetype\"),url(" + __webpack_require__("./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0") + ") format(\"woff\"),url(" + __webpack_require__("./node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0") + "#simple-line-icons) format(\"svg\");font-weight:400;font-style:normal}.icon-action-redo,.icon-action-undo,.icon-anchor,.icon-arrow-down,.icon-arrow-down-circle,.icon-arrow-left,.icon-arrow-left-circle,.icon-arrow-right,.icon-arrow-right-circle,.icon-arrow-up,.icon-arrow-up-circle,.icon-badge,.icon-bag,.icon-ban,.icon-basket,.icon-basket-loaded,.icon-bell,.icon-book-open,.icon-briefcase,.icon-bubble,.icon-bubbles,.icon-bulb,.icon-calculator,.icon-calendar,.icon-call-end,.icon-call-in,.icon-call-out,.icon-camera,.icon-camrecorder,.icon-chart,.icon-check,.icon-chemistry,.icon-clock,.icon-close,.icon-cloud-download,.icon-cloud-upload,.icon-compass,.icon-control-end,.icon-control-forward,.icon-control-pause,.icon-control-play,.icon-control-rewind,.icon-control-start,.icon-credit-card,.icon-crop,.icon-cup,.icon-cursor,.icon-cursor-move,.icon-diamond,.icon-direction,.icon-directions,.icon-disc,.icon-dislike,.icon-doc,.icon-docs,.icon-drawer,.icon-drop,.icon-earphones,.icon-earphones-alt,.icon-emotsmile,.icon-energy,.icon-envelope,.icon-envelope-letter,.icon-envelope-open,.icon-equalizer,.icon-event,.icon-exclamation,.icon-eye,.icon-eyeglass,.icon-feed,.icon-film,.icon-fire,.icon-flag,.icon-folder,.icon-folder-alt,.icon-frame,.icon-game-controller,.icon-ghost,.icon-globe,.icon-globe-alt,.icon-graduation,.icon-graph,.icon-grid,.icon-handbag,.icon-heart,.icon-home,.icon-hourglass,.icon-info,.icon-key,.icon-layers,.icon-like,.icon-link,.icon-list,.icon-location-pin,.icon-lock,.icon-lock-open,.icon-login,.icon-logout,.icon-loop,.icon-magic-wand,.icon-magnet,.icon-magnifier,.icon-magnifier-add,.icon-magnifier-remove,.icon-map,.icon-menu,.icon-microphone,.icon-minus,.icon-mouse,.icon-music-tone,.icon-music-tone-alt,.icon-mustache,.icon-note,.icon-notebook,.icon-options,.icon-options-vertical,.icon-organization,.icon-paper-clip,.icon-paper-plane,.icon-paypal,.icon-pencil,.icon-people,.icon-phone,.icon-picture,.icon-pie-chart,.icon-pin,.icon-plane,.icon-playlist,.icon-plus,.icon-power,.icon-present,.icon-printer,.icon-puzzle,.icon-question,.icon-refresh,.icon-reload,.icon-rocket,.icon-screen-desktop,.icon-screen-smartphone,.icon-screen-tablet,.icon-settings,.icon-share,.icon-share-alt,.icon-shield,.icon-shuffle,.icon-size-actual,.icon-size-fullscreen,.icon-social-behance,.icon-social-dribbble,.icon-social-dropbox,.icon-social-facebook,.icon-social-foursqare,.icon-social-github,.icon-social-google,.icon-social-instagram,.icon-social-linkedin,.icon-social-pinterest,.icon-social-reddit,.icon-social-skype,.icon-social-soundcloud,.icon-social-spotify,.icon-social-steam,.icon-social-stumbleupon,.icon-social-tumblr,.icon-social-twitter,.icon-social-vkontakte,.icon-social-youtube,.icon-speech,.icon-speedometer,.icon-star,.icon-support,.icon-symbol-female,.icon-symbol-male,.icon-tag,.icon-target,.icon-trash,.icon-trophy,.icon-umbrella,.icon-user,.icon-user-female,.icon-user-follow,.icon-user-following,.icon-user-unfollow,.icon-vector,.icon-volume-1,.icon-volume-2,.icon-volume-off,.icon-wallet,.icon-wrench{font-family:simple-line-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-user:before{content:\"\\E005\"}.icon-people:before{content:\"\\E001\"}.icon-user-female:before{content:\"\\E000\"}.icon-user-follow:before{content:\"\\E002\"}.icon-user-following:before{content:\"\\E003\"}.icon-user-unfollow:before{content:\"\\E004\"}.icon-login:before{content:\"\\E066\"}.icon-logout:before{content:\"\\E065\"}.icon-emotsmile:before{content:\"\\E021\"}.icon-phone:before{content:\"\\E600\"}.icon-call-end:before{content:\"\\E048\"}.icon-call-in:before{content:\"\\E047\"}.icon-call-out:before{content:\"\\E046\"}.icon-map:before{content:\"\\E033\"}.icon-location-pin:before{content:\"\\E096\"}.icon-direction:before{content:\"\\E042\"}.icon-directions:before{content:\"\\E041\"}.icon-compass:before{content:\"\\E045\"}.icon-layers:before{content:\"\\E034\"}.icon-menu:before{content:\"\\E601\"}.icon-list:before{content:\"\\E067\"}.icon-options-vertical:before{content:\"\\E602\"}.icon-options:before{content:\"\\E603\"}.icon-arrow-down:before{content:\"\\E604\"}.icon-arrow-left:before{content:\"\\E605\"}.icon-arrow-right:before{content:\"\\E606\"}.icon-arrow-up:before{content:\"\\E607\"}.icon-arrow-up-circle:before{content:\"\\E078\"}.icon-arrow-left-circle:before{content:\"\\E07A\"}.icon-arrow-right-circle:before{content:\"\\E079\"}.icon-arrow-down-circle:before{content:\"\\E07B\"}.icon-check:before{content:\"\\E080\"}.icon-clock:before{content:\"\\E081\"}.icon-plus:before{content:\"\\E095\"}.icon-minus:before{content:\"\\E615\"}.icon-close:before{content:\"\\E082\"}.icon-event:before{content:\"\\E619\"}.icon-exclamation:before{content:\"\\E617\"}.icon-organization:before{content:\"\\E616\"}.icon-trophy:before{content:\"\\E006\"}.icon-screen-smartphone:before{content:\"\\E010\"}.icon-screen-desktop:before{content:\"\\E011\"}.icon-plane:before{content:\"\\E012\"}.icon-notebook:before{content:\"\\E013\"}.icon-mustache:before{content:\"\\E014\"}.icon-mouse:before{content:\"\\E015\"}.icon-magnet:before{content:\"\\E016\"}.icon-energy:before{content:\"\\E020\"}.icon-disc:before{content:\"\\E022\"}.icon-cursor:before{content:\"\\E06E\"}.icon-cursor-move:before{content:\"\\E023\"}.icon-crop:before{content:\"\\E024\"}.icon-chemistry:before{content:\"\\E026\"}.icon-speedometer:before{content:\"\\E007\"}.icon-shield:before{content:\"\\E00E\"}.icon-screen-tablet:before{content:\"\\E00F\"}.icon-magic-wand:before{content:\"\\E017\"}.icon-hourglass:before{content:\"\\E018\"}.icon-graduation:before{content:\"\\E019\"}.icon-ghost:before{content:\"\\E01A\"}.icon-game-controller:before{content:\"\\E01B\"}.icon-fire:before{content:\"\\E01C\"}.icon-eyeglass:before{content:\"\\E01D\"}.icon-envelope-open:before{content:\"\\E01E\"}.icon-envelope-letter:before{content:\"\\E01F\"}.icon-bell:before{content:\"\\E027\"}.icon-badge:before{content:\"\\E028\"}.icon-anchor:before{content:\"\\E029\"}.icon-wallet:before{content:\"\\E02A\"}.icon-vector:before{content:\"\\E02B\"}.icon-speech:before{content:\"\\E02C\"}.icon-puzzle:before{content:\"\\E02D\"}.icon-printer:before{content:\"\\E02E\"}.icon-present:before{content:\"\\E02F\"}.icon-playlist:before{content:\"\\E030\"}.icon-pin:before{content:\"\\E031\"}.icon-picture:before{content:\"\\E032\"}.icon-handbag:before{content:\"\\E035\"}.icon-globe-alt:before{content:\"\\E036\"}.icon-globe:before{content:\"\\E037\"}.icon-folder-alt:before{content:\"\\E039\"}.icon-folder:before{content:\"\\E089\"}.icon-film:before{content:\"\\E03A\"}.icon-feed:before{content:\"\\E03B\"}.icon-drop:before{content:\"\\E03E\"}.icon-drawer:before{content:\"\\E03F\"}.icon-docs:before{content:\"\\E040\"}.icon-doc:before{content:\"\\E085\"}.icon-diamond:before{content:\"\\E043\"}.icon-cup:before{content:\"\\E044\"}.icon-calculator:before{content:\"\\E049\"}.icon-bubbles:before{content:\"\\E04A\"}.icon-briefcase:before{content:\"\\E04B\"}.icon-book-open:before{content:\"\\E04C\"}.icon-basket-loaded:before{content:\"\\E04D\"}.icon-basket:before{content:\"\\E04E\"}.icon-bag:before{content:\"\\E04F\"}.icon-action-undo:before{content:\"\\E050\"}.icon-action-redo:before{content:\"\\E051\"}.icon-wrench:before{content:\"\\E052\"}.icon-umbrella:before{content:\"\\E053\"}.icon-trash:before{content:\"\\E054\"}.icon-tag:before{content:\"\\E055\"}.icon-support:before{content:\"\\E056\"}.icon-frame:before{content:\"\\E038\"}.icon-size-fullscreen:before{content:\"\\E057\"}.icon-size-actual:before{content:\"\\E058\"}.icon-shuffle:before{content:\"\\E059\"}.icon-share-alt:before{content:\"\\E05A\"}.icon-share:before{content:\"\\E05B\"}.icon-rocket:before{content:\"\\E05C\"}.icon-question:before{content:\"\\E05D\"}.icon-pie-chart:before{content:\"\\E05E\"}.icon-pencil:before{content:\"\\E05F\"}.icon-note:before{content:\"\\E060\"}.icon-loop:before{content:\"\\E064\"}.icon-home:before{content:\"\\E069\"}.icon-grid:before{content:\"\\E06A\"}.icon-graph:before{content:\"\\E06B\"}.icon-microphone:before{content:\"\\E063\"}.icon-music-tone-alt:before{content:\"\\E061\"}.icon-music-tone:before{content:\"\\E062\"}.icon-earphones-alt:before{content:\"\\E03C\"}.icon-earphones:before{content:\"\\E03D\"}.icon-equalizer:before{content:\"\\E06C\"}.icon-like:before{content:\"\\E068\"}.icon-dislike:before{content:\"\\E06D\"}.icon-control-start:before{content:\"\\E06F\"}.icon-control-rewind:before{content:\"\\E070\"}.icon-control-play:before{content:\"\\E071\"}.icon-control-pause:before{content:\"\\E072\"}.icon-control-forward:before{content:\"\\E073\"}.icon-control-end:before{content:\"\\E074\"}.icon-volume-1:before{content:\"\\E09F\"}.icon-volume-2:before{content:\"\\E0A0\"}.icon-volume-off:before{content:\"\\E0A1\"}.icon-calendar:before{content:\"\\E075\"}.icon-bulb:before{content:\"\\E076\"}.icon-chart:before{content:\"\\E077\"}.icon-ban:before{content:\"\\E07C\"}.icon-bubble:before{content:\"\\E07D\"}.icon-camrecorder:before{content:\"\\E07E\"}.icon-camera:before{content:\"\\E07F\"}.icon-cloud-download:before{content:\"\\E083\"}.icon-cloud-upload:before{content:\"\\E084\"}.icon-envelope:before{content:\"\\E086\"}.icon-eye:before{content:\"\\E087\"}.icon-flag:before{content:\"\\E088\"}.icon-heart:before{content:\"\\E08A\"}.icon-info:before{content:\"\\E08B\"}.icon-key:before{content:\"\\E08C\"}.icon-link:before{content:\"\\E08D\"}.icon-lock:before{content:\"\\E08E\"}.icon-lock-open:before{content:\"\\E08F\"}.icon-magnifier:before{content:\"\\E090\"}.icon-magnifier-add:before{content:\"\\E091\"}.icon-magnifier-remove:before{content:\"\\E092\"}.icon-paper-clip:before{content:\"\\E093\"}.icon-paper-plane:before{content:\"\\E094\"}.icon-power:before{content:\"\\E097\"}.icon-refresh:before{content:\"\\E098\"}.icon-reload:before{content:\"\\E099\"}.icon-settings:before{content:\"\\E09A\"}.icon-star:before{content:\"\\E09B\"}.icon-symbol-female:before{content:\"\\E09C\"}.icon-symbol-male:before{content:\"\\E09D\"}.icon-target:before{content:\"\\E09E\"}.icon-credit-card:before{content:\"\\E025\"}.icon-paypal:before{content:\"\\E608\"}.icon-social-tumblr:before{content:\"\\E00A\"}.icon-social-twitter:before{content:\"\\E009\"}.icon-social-facebook:before{content:\"\\E00B\"}.icon-social-instagram:before{content:\"\\E609\"}.icon-social-linkedin:before{content:\"\\E60A\"}.icon-social-pinterest:before{content:\"\\E60B\"}.icon-social-github:before{content:\"\\E60C\"}.icon-social-google:before{content:\"\\E60D\"}.icon-social-reddit:before{content:\"\\E60E\"}.icon-social-skype:before{content:\"\\E60F\"}.icon-social-dribbble:before{content:\"\\E00D\"}.icon-social-behance:before{content:\"\\E610\"}.icon-social-foursqare:before{content:\"\\E611\"}.icon-social-soundcloud:before{content:\"\\E612\"}.icon-social-spotify:before{content:\"\\E613\"}.icon-social-stumbleupon:before{content:\"\\E614\"}.icon-social-youtube:before{content:\"\\E008\"}.icon-social-dropbox:before{content:\"\\E00C\"}.icon-social-vkontakte:before{content:\"\\E618\"}.icon-social-steam:before{content:\"\\E620\"}", ""]);
	
	// exports


/***/ }),

/***/ "./node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Simple-Line-Icons.f33df365.eot";

/***/ }),

/***/ "./node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Simple-Line-Icons.2fe2efe6.svg";

/***/ }),

/***/ "./node_modules/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Simple-Line-Icons.d2285965.ttf";

/***/ }),

/***/ "./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Simple-Line-Icons.0cb0b9c5.woff2";

/***/ }),

/***/ "./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Simple-Line-Icons.78f07e2c.woff";

/***/ }),

/***/ "./src/components/base/doximityLogin.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themes = __webpack_require__("./src/themes/index.js");
	
	var _doximitySDK = __webpack_require__("./src/lib/doximitySDK.js");
	
	var _doximitySDK2 = _interopRequireDefault(_doximitySDK);
	
	var _loginDoximity = __webpack_require__("./src/media/loginDoximity.png");
	
	var _loginDoximity2 = _interopRequireDefault(_loginDoximity);
	
	var _verifyDoximity = __webpack_require__("./src/media/verifyDoximity.png");
	
	var _verifyDoximity2 = _interopRequireDefault(_verifyDoximity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      style = _ref.style,
	      to = _ref.to,
	      onClick = _ref.onClick,
	      _ref$imageType = _ref.imageType,
	      imageType = _ref$imageType === undefined ? 'login' : _ref$imageType,
	      referralSlug = _ref.referralSlug;
	
	  var defaultStyle = {
	    width: '100%',
	    maxWidth: 250,
	    cursor: 'pointer'
	  };
	
	  var onClickLocal = function onClickLocal() {
	    if (typeof window != 'undefined') {
	      var hostname = window.location.hostname;
	      var href = 'https://us-central1-oncallogy-177220.cloudfunctions.net/redirect?source=' + hostname;
	      if (referralSlug) {
	        href = href + '?referralSlug=' + referralSlug;
	      }
	      window.location.href = href;
	    }
	    onClick();
	  };
	
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement('img', {
	      src: imageType === 'login' ? _loginDoximity2.default : _verifyDoximity2.default,
	      css: _extends({}, defaultStyle, style),
	      onClick: onClickLocal
	    })
	  );
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/base/hero.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _themes = __webpack_require__("./src/themes/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  outer: {
	    minHeight: '90vh',
	    position: 'relative'
	  },
	  inner: _extends({}, _themes.applicationStyles.mainTextContainer, {
	    display: 'flex',
	    flex: 1,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'column',
	    textAlign: 'center',
	    minHeight: '90vh'
	  })
	};
	
	var Hero = function Hero(_ref) {
	  var children = _ref.children,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      backgroundColor = _ref.backgroundColor;
	  return Glamor.createElement(
	    'div',
	    { css: _extends({}, styles.outer, { backgroundColor: backgroundColor }) },
	    Glamor.createElement(
	      'div',
	      { css: _extends({}, styles.inner, style) },
	      children
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/hybrid/benefits.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _container;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHeadroom = __webpack_require__("./node_modules/react-headroom/dist/index.js");
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	var _link = __webpack_require__("./src/components/base/link.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _themes = __webpack_require__("./src/themes/index.js");
	
	var _Grid = __webpack_require__("./node_modules/material-ui/Grid/index.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _presets = __webpack_require__("./src/lib/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _FolderSpecial = __webpack_require__("./node_modules/material-ui-icons/FolderSpecial.js");
	
	var _FolderSpecial2 = _interopRequireDefault(_FolderSpecial);
	
	var _reactSimpleLineIcons = __webpack_require__("./node_modules/react-simple-line-icons/dist/index.js");
	
	var _reactSimpleLineIcons2 = _interopRequireDefault(_reactSimpleLineIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendar = __webpack_require__("./node_modules/react-icons/lib/fa/calendar.js");
	
	var styles = {
	  avatar: {
	    backgroundColor: _themes.colors.green,
	    color: _themes.colors.white,
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'column',
	    justifyContent: 'center',
	    alignItems: 'center',
	    padding: 10,
	    borderRadius: '100%'
	  },
	  container: (_container = {
	    display: 'flex',
	    flexDirection: 'column',
	    alignSelf: 'center',
	    justifyContent: 'space-around',
	    width: '100%',
	    maxWidth: 800,
	    padding: 20
	  }, _container[_presets2.default.Tablet] = {
	    flexDirection: 'row'
	  }, _container),
	  iconHolder: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'center',
	    alignItems: 'center',
	    width: 80,
	    height: 80,
	    backgroundColor: _themes.colors.green,
	    borderRadius: '100%'
	  },
	  icon: {
	    width: 30,
	    height: 30,
	    color: _themes.colors.white
	  },
	  text: {
	    color: _themes.colors.darkBlue,
	    textAlign: 'center'
	  },
	  item: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'center',
	    alignItems: 'center'
	  }
	};
	
	var stepData = [{
	  title: Glamor.createElement(
	    'p',
	    { css: styles.text },
	    'Centralized Credentialing'
	  ),
	  icon: Glamor.createElement(_reactSimpleLineIcons2.default, { name: 'badge', size: 'Large', color: _themes.colors.white })
	}, {
	  title: Glamor.createElement(
	    'p',
	    { css: styles.text },
	    ' Malpractice Coverage'
	  ),
	  icon: Glamor.createElement(_FolderSpecial2.default, { style: _extends({}, styles.icon, { width: 35, height: 35 }) })
	}, {
	  title: Glamor.createElement(
	    'p',
	    { css: styles.text },
	    'Seamless Calendaring'
	  ),
	  icon: Glamor.createElement(FaCalendar, { style: styles.icon })
	}];
	
	var Step = function Step(_ref) {
	  var step = _ref.step,
	      title = _ref.title,
	      icon = _ref.icon;
	  return Glamor.createElement(
	    'div',
	    { key: step, css: styles.item },
	    Glamor.createElement(
	      'div',
	      { css: styles.iconHolder },
	      icon
	    ),
	    title
	  );
	};
	
	var Steps = function Steps() {
	  var stepElements = stepData.map(function (currentStep, index) {
	    return Glamor.createElement(Step, _extends({}, currentStep, { step: index + 1 }));
	  });
	  return Glamor.createElement(
	    'div',
	    { css: styles.container },
	    stepElements
	  );
	};
	
	exports.default = Steps;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/components/hybrid/steps.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _left, _right;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHeadroom = __webpack_require__("./node_modules/react-headroom/dist/index.js");
	
	var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);
	
	var _link = __webpack_require__("./src/components/base/link.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _themes = __webpack_require__("./src/themes/index.js");
	
	var _Grid = __webpack_require__("./node_modules/material-ui/Grid/index.js");
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _presets = __webpack_require__("./src/lib/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stepData = [{
	  title: 'Create profile',
	  description: 'We auto-populate your info from Doximity and let you customize it.'
	}, {
	  title: 'Upload Credentialing Info',
	  description: "We securely store it in the cloud so that you can use the same information for multiple hospitals."
	}, {
	  title: 'Connect with hospitals',
	  description: "Filter local hospitals based on your experience & proximity, then connect with those you like."
	}, {
	  title: 'Get to work',
	  description: "Pick up shifts whenever YOU want."
	}];
	
	var styles = {
	  container: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'stretch'
	  },
	  row: {
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'stretch'
	  },
	  center: {
	    border: '3px solid ' + _themes.colors.green,
	    height: '150px',
	    position: 'relative'
	  },
	  numberCircle: {
	    position: 'absolute',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    backgroundColor: _themes.colors.green,
	    top: -5,
	    width: 35,
	    height: 35,
	    borderRadius: '100%',
	    color: _themes.colors.white,
	    marginLeft: -17.5
	  },
	  left: (_left = {
	    display: 'none'
	  }, _left[_presets2.default.Tablet] = {
	    display: 'flex',
	    flex: 0.5
	  }, _left.marginTop = '-120px', _left.paddingRight = '60px', _left.flexDirection = 'column', _left.justifyContent = 'flex-start', _left.textAlign = 'right', _left),
	  right: (_right = {
	    marginTop: '-120px',
	    display: 'flex'
	  }, _right[_presets2.default.Tablet] = {
	    display: 'flex',
	    flex: 0.5,
	    paddingLeft: '60px'
	  }, _right.width = '90%', _right.paddingLeft = '30px', _right.paddingRight = '10px', _right.flexDirection = 'column', _right.justifyContent = 'flex-start', _right.alignItems = 'flex-start', _right.textAlign = 'left', _right),
	  title: {
	    color: _themes.colors.white,
	    alignSelf: 'stretch',
	    marginBottom: '10px'
	  },
	  description: {
	    color: _themes.colors.white,
	    alignSelf: 'stretch',
	    margin: 0
	  }
	};
	
	var Step = function Step(_ref) {
	  var _ref2;
	
	  var step = _ref.step,
	      title = _ref.title,
	      description = _ref.description;
	
	  var text = Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'h3',
	      { css: styles.title },
	      title
	    ),
	    Glamor.createElement(
	      'p',
	      { css: styles.description },
	      description
	    )
	  );
	  return Glamor.createElement(
	    'div',
	    { css: styles.row },
	    Glamor.createElement(
	      'div',
	      { css: styles.left },
	      step % 2 !== 0 && text
	    ),
	    Glamor.createElement(
	      'div',
	      { css: _extends({}, styles.center, { border: step === stepData.length ? null : styles.center.border }) },
	      Glamor.createElement(
	        'div',
	        { css: styles.numberCircle },
	        step
	      )
	    ),
	    Glamor.createElement(
	      'div',
	      { css: styles.right },
	      Glamor.createElement(
	        'div',
	        { css: (_ref2 = {}, _ref2[_presets2.default.Tablet] = { display: step % 2 === 0 ? null : 'none' }, _ref2) },
	        text
	      )
	    )
	  );
	};
	
	var Steps = function Steps() {
	  var stepElements = stepData.map(function (currentStep, index) {
	    return Glamor.createElement(Step, _extends({}, currentStep, { step: index + 1 }));
	  });
	  return Glamor.createElement(
	    'div',
	    { css: styles.conatiner },
	    stepElements
	  );
	};
	
	exports.default = Steps;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./src/lib/doximitySDK.js":
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var baseURL = 'https://auth.doximity.com';
	var clientID = '22dd7b5b68e9ad688404cacbf1d983baf238624dc9f310d9597dfeae21a3c7a1';
	var doximityModule = function doximityModule() {
	  var apiRoot = baseURL;
	
	  var api = {};
	
	  api.initiateOauth = function (_ref) {
	    var redirectURI = _ref.redirectURI,
	        uniqueString = _ref.uniqueString;
	
	    var url = apiRoot + '/oauth/authorize?client_id=' + clientID + '&response_type=code&redirect_uri=' + redirectURI + '&scope=basic%20colleagues&type=verify&state=' + uniqueString;
	    if (typeof location != 'undefined') {
	      location.href = url;
	    }
	  };
	
	  return api;
	};
	
	var doximity = doximityModule();
	
	exports.default = doximity;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/lib/jobs.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _places = __webpack_require__("./src/lib/places.js");
	
	var _places2 = _interopRequireDefault(_places);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fillTemplate = function fillTemplate(_ref) {
	  var city = _ref.city,
	      state = _ref.state;
	
	  return {
	    "@type": "JobPosting",
	    "baseSalary": {
	      "@type": "MonetaryAmount",
	      "currency": "USD",
	      "value": {
	        "@type": "QuantitativeValue",
	        "minValue": 100.00,
	        "maxValue": 200.00,
	        "unitText": "HOUR"
	      }
	    },
	    "datePosted": new Date().toISOString().slice(0, 10),
	    "employmentType": "CONTRACTOR",
	    "hiringOrganization": {
	      "@type": "Organization",
	      "name": "OnCallogy",
	      "sameAs": "https://www.oncallogy.com"
	    },
	    "jobLocation": {
	      "@type": "Place",
	      "address": {
	        "@type": "PostalAddress",
	        "addressLocality": city,
	        "addressRegion": state,
	        "addressCountry": "US"
	      }
	    },
	    "description": "OnCallogy is an app that allows physicians to find local moonlighting shifts. Register at www.oncallogy.com and find moonlighting opportunities near you today.",
	    "title": "Moonlighting Physician in " + city + ", " + state
	  };
	}; // Generate jobs schema
	// This will create the script tag that goes inside of the Main Helmet
	
	exports.default = function () {
	  var postings = [];
	  _places2.default.map(function (place) {
	    postings.push(fillTemplate(place));
	  });
	  return {
	    "type": "application/ld+json",
	    "innerHTML": JSON.stringify({
	      "@context": "https://schema.org",
	      "@graph": postings
	    })
	  };
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/lib/places.js":
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	    "city": "New York",
	    "state": "New York"
	}, {
	    "city": "Los Angeles",
	    "state": "California"
	}, {
	    "city": "Chicago",
	    "state": "Illinois"
	}, {
	    "city": "Houston",
	    "state": "Texas"
	}, {
	    "city": "Philadelphia",
	    "state": "Pennsylvania"
	}, {
	    "city": "Phoenix",
	    "state": "Arizona"
	}, {
	    "city": "San Antonio",
	    "state": "Texas"
	}, {
	    "city": "San Diego",
	    "state": "California"
	}, {
	    "city": "Dallas",
	    "state": "Texas"
	}, {
	    "city": "San Jose",
	    "state": "California"
	}, {
	    "city": "Austin",
	    "state": "Texas"
	}, {
	    "city": "Indianapolis",
	    "state": "Indiana"
	}, {
	    "city": "Jacksonville",
	    "state": "Florida"
	}, {
	    "city": "San Francisco",
	    "state": "California"
	}, {
	    "city": "Columbus",
	    "state": "Ohio"
	}, {
	    "city": "Charlotte",
	    "state": "North Carolina"
	}, {
	    "city": "Fort Worth",
	    "state": "Texas"
	}, {
	    "city": "Detroit",
	    "state": "Michigan"
	}, {
	    "city": "El Paso",
	    "state": "Texas"
	}, {
	    "city": "Memphis",
	    "state": "Tennessee"
	}, {
	    "city": "Seattle",
	    "state": "Washington"
	}, {
	    "city": "Denver",
	    "state": "Colorado"
	}, {
	    "city": "Washington",
	    "state": "District of Columbia"
	}, {
	    "city": "Boston",
	    "state": "Massachusetts"
	}, {
	    "city": "Nashville-Davidson",
	    "state": "Tennessee"
	}, {
	    "city": "Baltimore",
	    "state": "Maryland"
	}, {
	    "city": "Oklahoma City",
	    "state": "Oklahoma"
	}, {
	    "city": "Louisville/Jefferson County",
	    "state": "Kentucky"
	}, {
	    "city": "Portland",
	    "state": "Oregon"
	}, {
	    "city": "Las Vegas",
	    "state": "Nevada"
	}, {
	    "city": "Milwaukee",
	    "state": "Wisconsin"
	}, {
	    "city": "Albuquerque",
	    "state": "New Mexico"
	}, {
	    "city": "Tucson",
	    "state": "Arizona"
	}, {
	    "city": "Fresno",
	    "state": "California"
	}, {
	    "city": "Sacramento",
	    "state": "California"
	}, {
	    "city": "Long Beach",
	    "state": "California"
	}, {
	    "city": "Kansas City",
	    "state": "Missouri"
	}, {
	    "city": "Mesa",
	    "state": "Arizona"
	}, {
	    "city": "Virginia Beach",
	    "state": "Virginia"
	}, {
	    "city": "Atlanta",
	    "state": "Georgia"
	}, {
	    "city": "Colorado Springs",
	    "state": "Colorado"
	}, {
	    "city": "Omaha",
	    "state": "Nebraska"
	}, {
	    "city": "Raleigh",
	    "state": "North Carolina"
	}, {
	    "city": "Miami",
	    "state": "Florida"
	}, {
	    "city": "Oakland",
	    "state": "California"
	}, {
	    "city": "Minneapolis",
	    "state": "Minnesota"
	}, {
	    "city": "Tulsa",
	    "state": "Oklahoma"
	}, {
	    "city": "Cleveland",
	    "state": "Ohio"
	}, {
	    "city": "Wichita",
	    "state": "Kansas"
	}, {
	    "city": "Arlington",
	    "state": "Texas"
	}, {
	    "city": "New Orleans",
	    "state": "Louisiana"
	}, {
	    "city": "Bakersfield",
	    "state": "California"
	}, {
	    "city": "Tampa",
	    "state": "Florida"
	}, {
	    "city": "Honolulu",
	    "state": "Hawaii"
	}, {
	    "city": "Aurora",
	    "state": "Colorado"
	}, {
	    "city": "Anaheim",
	    "state": "California"
	}, {
	    "city": "Santa Ana",
	    "state": "California"
	}, {
	    "city": "St. Louis",
	    "state": "Missouri"
	}, {
	    "city": "Riverside",
	    "state": "California"
	}, {
	    "city": "Corpus Christi",
	    "state": "Texas"
	}, {
	    "city": "Lexington-Fayette",
	    "state": "Kentucky"
	}, {
	    "city": "Pittsburgh",
	    "state": "Pennsylvania"
	}, {
	    "city": "Anchorage",
	    "state": "Alaska"
	}, {
	    "city": "Stockton",
	    "state": "California"
	}, {
	    "city": "Cincinnati",
	    "state": "Ohio"
	}, {
	    "city": "St. Paul",
	    "state": "Minnesota"
	}, {
	    "city": "Toledo",
	    "state": "Ohio"
	}, {
	    "city": "Greensboro",
	    "state": "North Carolina"
	}, {
	    "city": "Newark",
	    "state": "New Jersey"
	}, {
	    "city": "Plano",
	    "state": "Texas"
	}, {
	    "city": "Henderson",
	    "state": "Nevada"
	}, {
	    "city": "Lincoln",
	    "state": "Nebraska"
	}, {
	    "city": "Buffalo",
	    "state": "New York"
	}, {
	    "city": "Jersey City",
	    "state": "New Jersey"
	}, {
	    "city": "Chula Vista",
	    "state": "California"
	}, {
	    "city": "Fort Wayne",
	    "state": "Indiana"
	}, {
	    "city": "Orlando",
	    "state": "Florida"
	}, {
	    "city": "St. Petersburg",
	    "state": "Florida"
	}, {
	    "city": "Chandler",
	    "state": "Arizona"
	}, {
	    "city": "Laredo",
	    "state": "Texas"
	}, {
	    "city": "Norfolk",
	    "state": "Virginia"
	}, {
	    "city": "Durham",
	    "state": "North Carolina"
	}, {
	    "city": "Madison",
	    "state": "Wisconsin"
	}, {
	    "city": "Lubbock",
	    "state": "Texas"
	}, {
	    "city": "Irvine",
	    "state": "California"
	}, {
	    "city": "Winston-Salem",
	    "state": "North Carolina"
	}, {
	    "city": "Glendale",
	    "state": "Arizona"
	}, {
	    "city": "Garland",
	    "state": "Texas"
	}, {
	    "city": "Hialeah",
	    "state": "Florida"
	}, {
	    "city": "Reno",
	    "state": "Nevada"
	}, {
	    "city": "Chesapeake",
	    "state": "Virginia"
	}, {
	    "city": "Gilbert",
	    "state": "Arizona"
	}, {
	    "city": "Baton Rouge",
	    "state": "Louisiana"
	}, {
	    "city": "Irving",
	    "state": "Texas"
	}, {
	    "city": "Scottsdale",
	    "state": "Arizona"
	}, {
	    "city": "North Las Vegas",
	    "state": "Nevada"
	}, {
	    "city": "Fremont",
	    "state": "California"
	}, {
	    "city": "Boise City",
	    "state": "Idaho"
	}, {
	    "city": "Richmond",
	    "state": "Virginia"
	}, {
	    "city": "San Bernardino",
	    "state": "California"
	}];
	module.exports = exports["default"];

/***/ }),

/***/ "./src/media/calendarIphone.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/calendarIphone.032fa6af.png";

/***/ }),

/***/ "./src/media/docTorso.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/docTorso.962ebac6.png";

/***/ }),

/***/ "./src/media/doctors6.png":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/doctors6.8dc9647c.png";

/***/ }),

/***/ "./src/media/loginDoximity.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/media/verifyDoximity.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",[\"/opt/build/repo/node_modules/babel-plugin-module-alias/lib/index.js\",[{\"src\":\"./src/components\",\"expose\":\"components\"},{\"src\":\"./src/components/base\",\"expose\":\"baseComponents\"},{\"src\":\"./src/components/hybrid\",\"expose\":\"hybridComponents\"},{\"src\":\"./src/config\",\"expose\":\"config\"},{\"src\":\"./src/layouts\",\"expose\":\"layouts\"},{\"src\":\"./src/lib\",\"expose\":\"lib\"},{\"src\":\"./src/pages\",\"expose\":\"pages\"},{\"src\":\"./src/stories\",\"expose\":\"stories\"},{\"src\":\"./src/themes\",\"expose\":\"themes\"},{\"src\":\"./src/media\",\"expose\":\"media\"}]],\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _link = __webpack_require__("./src/components/base/link.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _docTorso = __webpack_require__("./src/media/docTorso.png");
	
	var _docTorso2 = _interopRequireDefault(_docTorso);
	
	var _hero = __webpack_require__("./src/components/base/hero.js");
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _steps = __webpack_require__("./src/components/hybrid/steps.js");
	
	var _steps2 = _interopRequireDefault(_steps);
	
	var _benefits = __webpack_require__("./src/components/hybrid/benefits.js");
	
	var _benefits2 = _interopRequireDefault(_benefits);
	
	var _Button = __webpack_require__("./node_modules/material-ui/Button/index.js");
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _themes = __webpack_require__("./src/themes/index.js");
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _doctors = __webpack_require__("./src/media/doctors6.png");
	
	var _doctors2 = _interopRequireDefault(_doctors);
	
	var _doximityLogin = __webpack_require__("./src/components/base/doximityLogin.js");
	
	var _doximityLogin2 = _interopRequireDefault(_doximityLogin);
	
	var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _loading = __webpack_require__("./src/components/base/loading.js");
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _calendarIphone = __webpack_require__("./src/media/calendarIphone.png");
	
	var _calendarIphone2 = _interopRequireDefault(_calendarIphone);
	
	var _mainHelmet = __webpack_require__("./src/components/base/mainHelmet.js");
	
	var _mainHelmet2 = _interopRequireDefault(_mainHelmet);
	
	var _jobs = __webpack_require__("./src/lib/jobs.js");
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _withAuth = __webpack_require__("./src/components/hocs/withAuth.js");
	
	var _withAuth2 = _interopRequireDefault(_withAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  second: {
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'column',
	    justifyContent: 'center',
	    alignItems: 'center',
	    backgroundColor: _themes.colors.white,
	    padding: 45
	  },
	  mock: {
	    width: '80%',
	    maxWidth: 200
	  },
	  button: {
	    margin: '20px',
	    cursor: 'pointer',
	    color: _themes.colors.darkBlue,
	    backgroundColor: _themes.colors.white,
	    padding: 20,
	    borderRadius: 10,
	    fontSize: '1.5em'
	  }
	};
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      loading: false,
	      referralSlug: null
	    };
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ referralSlug: _jsCookie2.default.get('referralSlug') });
	  };
	
	  IndexPage.prototype.onClick = function onClick() {
	    GA('send', {
	      hitType: 'event',
	      eventCategory: 'Auth',
	      eventAction: 'Signup',
	      eventLabel: 'Doximity'
	    });
	    this.setState({ loading: true });
	  };
	
	  IndexPage.prototype.render = function render() {
	    if (this.props.user) {
	      // They are logged in, redirect to app
	      (0, _gatsbyLink.navigateTo)('/app/opportunities');
	    }
	    if (this.state.loading) {
	      return Glamor.createElement(_loading2.default, null);
	    }
	    return Glamor.createElement(
	      'div',
	      { css: { display: 'flex', flex: 1, flexDirection: 'column' } },
	      Glamor.createElement(_mainHelmet2.default, { script: (0, _jobs2.default)() }),
	      Glamor.createElement(
	        _hero2.default,
	        { backgroundColor: _themes.colors.darkBlue },
	        Glamor.createElement('img', { src: _doctors2.default, css: { maxHeight: 170, maxWidth: '80%' } }),
	        Glamor.createElement(
	          'h1',
	          { css: { color: _themes.colors.white } },
	          'Moonlighting Simplified.'
	        ),
	        Glamor.createElement('div', { css: { width: '80%', maxWidth: 800, borderBottom: '3px solid ' + _themes.colors.green } }),
	        Glamor.createElement(
	          'p',
	          { css: { color: _themes.colors.white } },
	          'Sign up for the beta!'
	        ),
	        Glamor.createElement(_doximityLogin2.default, {
	          onClick: this.onClick,
	          imageType: 'verify',
	          referralSlug: this.state.referralSlug
	        })
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.second },
	        Glamor.createElement(
	          'h2',
	          { css: { color: _themes.colors.darkBlue, textAlign: 'center' } },
	          'Work on your own time with local hospitals'
	        ),
	        Glamor.createElement(_benefits2.default, null)
	      ),
	      Glamor.createElement(
	        _hero2.default,
	        { backgroundColor: _themes.colors.darkBlue },
	        Glamor.createElement(
	          'h1',
	          { css: { color: _themes.colors.white, marginBottom: '80px' } },
	          'Here\'s how we work'
	        ),
	        Glamor.createElement(_steps2.default, null)
	      ),
	      Glamor.createElement(
	        'div',
	        { css: styles.second },
	        Glamor.createElement(
	          'h2',
	          { css: { color: _themes.colors.darkBlue, textAlign: 'center' } },
	          'Simple is Better.'
	        ),
	        Glamor.createElement('img', { src: _calendarIphone2.default, css: styles.mock })
	      ),
	      Glamor.createElement(
	        'div',
	        { css: _extends({}, styles.second, { backgroundColor: _themes.colors.darkBlue }) },
	        Glamor.createElement(
	          'div',
	          { css: styles.button, onClick: function onClick() {
	              return (0, _gatsbyLink.navigateTo)('/beta');
	            } },
	          'Join the Beta!'
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = (0, _withAuth2.default)(IndexPage, _withAuth.publicAuth);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-3b0a47bc26f48e2fea0f.js